//document add event listener for DOMContentLoaded on #bulk-add-to-cart
document.addEventListener("DOMContentLoaded", function () {
  const bulkAddToCartButton = document.getElementById("bulk-add-to-cart");
  if (bulkAddToCartButton) {
    bulkAddToCartButton.addEventListener("click", function (event) {      
      const productId = Number(this.getAttribute("data-product-id"));

      let formData = {
        items: [
          {
            id: productId,
            quantity: 1,
          },
        ],
      };

      fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
        .then((response) => {
          return response.json();
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    });
  }
});
